import React, { FC } from 'react';
import { AppDispatch, RootState } from '../store';
import { useSelector, useDispatch } from 'react-redux';
import {
	Orientation,
	DeviceType,
	Lightbox,
	WriteDirection,
	AppView,
	ArmrestsByCover,
	Platform,
} from 'sofa-reborn-react';
import { ProductData } from '@ikea-aoa/component-view-3d';
import BuildArea from '../components/BuildArea';
import { localeService } from '../services';
import { hidePopOver, setBannerHasBeenShown } from '../store/popOver';

const getRight = (writeDirection: WriteDirection, platform: Platform): string => {
	const wrapperWidth = document.getElementById('applicationWrapper')?.clientWidth || 0;
	const selectorWidth = document.getElementById('selector')?.clientWidth || 0;

	return writeDirection === 'ltr'
		? (window.innerWidth - wrapperWidth) / 2 + selectorWidth + 11 + 'px'
		: window.innerWidth - selectorWidth + (platform === 'kiosk' ? 74 : 55) + 'px';
};

const onCloseAllPopovers = (dispatch: AppDispatch): void => {
	dispatch(hidePopOver({ type: 'all' }));
	dispatch(hidePopOver({ type: 'placement-information' }));
};

const onCloseAllBanners = (dispatch: AppDispatch) => {
	dispatch(setBannerHasBeenShown(true));
};

const BuildAreaContainer: FC = () => {
	const orientation = useSelector<RootState, Orientation>((state) => state.deviceInfo.orientation);
	const deviceType = useSelector<RootState, DeviceType>((state) => state.deviceInfo.deviceType);
	const writeDirection = useSelector<RootState, WriteDirection>(
		(state) => state.localization.writeDirection
	);
	const appView = useSelector<RootState, AppView>((state) => state.application.appView);
	const currentLightbox = useSelector<RootState, Lightbox>(
		(state) => state.application.currentLightbox
	);
	const actionButtonsVisible = useSelector<RootState, boolean>(
		(state) => state.actionButtons.actionButtonsVisible
	);
	const dragSceneItemId = useSelector<RootState, string>(
		(state) => state.scene.dragSceneItemId as string
	);
	const dragSceneItemArticleId = useSelector<RootState, string>(
		(state) => state.swiper.dragItemId as string
	);
	const overSceneItemId = useSelector<RootState, string>(
		(state) => state.scene.overSceneItemId as string
	);
	const pointerOverDragArea = useSelector<RootState, boolean>(
		(state) => state.scene.pointerOverDropArea
	);
	const footerHeight = useSelector<RootState, number>(
		(state) => state.application.footerHeight as number
	);
	const armrests = useSelector<RootState, ArmrestsByCover | null>(
		(state) => state.armrest.armrests
	);
	const coverOnly = useSelector<RootState, boolean | undefined>((state) => state.cover.coverOnly);
	const platform = useSelector<RootState, Platform>((state) => state.deviceInfo.platform);
	const hasArmrestPicker = armrests ? true : false;
	const showBanner =
		localeService.getApplicationSetting('plannerBannerMessageEnabled')?.toString() === 'true' ||
		false;
	const bannerHasBeenShown = useSelector<RootState, boolean>(
		(state) => state.popOver.bannerHasBeenShown
	);
	const productData = useSelector<RootState, ProductData>((state) => state.products.products);

	const disableInput = appView !== 'build-view' || currentLightbox !== 'none';
	const showArea = currentLightbox !== 'product-intro-gallery' && appView === 'build-view';
	const showDeleteOverlay =
		dragSceneItemArticleId && !productData[dragSceneItemArticleId].filter.noArticleId;
	const dispatch = useDispatch<AppDispatch>();

	return (
		<BuildArea
			orientation={orientation}
			deviceType={deviceType}
			platform={platform}
			writeDirection={writeDirection}
			showBanner={showBanner}
			bannerHasBeenShown={bannerHasBeenShown}
			actionButtonsVisible={actionButtonsVisible}
			disableInput={disableInput}
			dragSceneItemId={dragSceneItemId}
			overSceneItemId={overSceneItemId}
			pointerOverDragArea={pointerOverDragArea}
			footerHeight={footerHeight}
			hasArmrestPicker={hasArmrestPicker}
			coverOnly={coverOnly}
			right={getRight(writeDirection, platform)}
			showArea={showArea}
			showDeleteOverlay={showDeleteOverlay as boolean}
			onCloseAllPopovers={(): void => onCloseAllPopovers(dispatch)}
			onCloseAllBanners={(): void => onCloseAllBanners(dispatch)}
		></BuildArea>
	);
};

export default BuildAreaContainer;
